import axios from 'axios';

let cl_accessToken = '';
let cl_refreshing: Promise<string> | null = null;

export const cl_api = axios.create({ baseURL: import.meta.env.VITE_API_BASE_URL ?? '/api', withCredentials: true, timeout: 30_000 });

export function cl_setAccessToken(cl_token: string) { cl_accessToken = cl_token; }

cl_api.interceptors.request.use((cl_config) => {
  if (cl_accessToken) cl_config.headers.Authorization = `Bearer ${cl_accessToken}`;
  return cl_config;
});

cl_api.interceptors.response.use(undefined, async (cl_error) => {
  const cl_request = cl_error.config;
  if (cl_error.response?.status !== 401 || cl_request?.cl_retried || cl_request?.url?.includes('/auth/')) throw cl_error;
  cl_request.cl_retried = true;
  cl_refreshing ??= cl_api.post('/auth/refresh').then((cl_response) => {
    const cl_token = cl_response.data.cl_accessToken as string;
    cl_setAccessToken(cl_token);
    return cl_token;
  }).finally(() => { cl_refreshing = null; });
  const cl_token = await cl_refreshing;
  cl_request.headers.Authorization = `Bearer ${cl_token}`;
  return cl_api(cl_request);
});

export function cl_errorMessage(cl_error: unknown) {
  if (axios.isAxiosError(cl_error)) {
    const cl_message = cl_error.response?.data?.message;
    return Array.isArray(cl_message) ? cl_message.join('；') : cl_message ?? (cl_error.code === 'ECONNABORTED' ? '请求超时，请检查网络后重试' : '网络连接失败，请稍后重试');
  }
  return '发生了意外错误，请稍后重试';
}
